const MAX_MESSAGE_LENGTH = 450;

const PRODUCTION_CHAT_URL = 'https://chat.onthesnow.com/';

function sanitizeUserMessage(message: string): string {
  let sanitized = message.trim();
  sanitized = sanitized.replace(/\n{3,}/g, '\n\n');
  return sanitized;
}

function truncateMessage(message: string, maxLength: number): string {
  if (message.length <= maxLength) {
    return message;
  }

  const truncated = message.slice(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');

  if (lastSpaceIndex > maxLength * 0.8) {
    return truncated.slice(0, lastSpaceIndex);
  }

  return truncated;
}

function buildChatUrl(sanitizedMessage: string): string | null {
  const domain = PRODUCTION_CHAT_URL;

  if (!domain) {
    return null;
  }

  const encodedMessage = encodeURIComponent(sanitizedMessage);

  return `${domain}?userQuery=${encodedMessage}`;
}

function openUrlSafely(url: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

  if (newWindow) {
    newWindow.opener = null;
  }
}

export function sendMessageToAiAssistant(userMessage: string): void {
  if (!userMessage || typeof userMessage !== 'string') {
    return;
  }

  const sanitized = sanitizeUserMessage(userMessage);

  if (!sanitized) {
    return;
  }

  const truncated = truncateMessage(sanitized, MAX_MESSAGE_LENGTH);
  const chatUrl = buildChatUrl(truncated);

  if (!chatUrl) {
    return;
  }

  openUrlSafely(chatUrl);
}
